import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkprocessComponent } from './workprocess/workprocess.component';
import { RouterModule } from '@angular/router';
import { AssessmentFormComponent } from './assessment-form/assessment-form.component';
import { MatRadioModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule, MatSlideToggleModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WorkprocessService } from './workprocess.service';
import { ExplanationService } from 'app/examination/explanation.service';
import { AssessmentCriteriaService } from './assessment-criteria.service';
import { SemsoSnackbarService } from '../../semso-snackbar.service';
import { GradeService } from 'app/examination/workprocess/grade.service';

@NgModule({
  imports: [
    CommonModule,
    MatRadioModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    ReactiveFormsModule
  ],
  declarations: [WorkprocessComponent, AssessmentFormComponent],
  providers: [WorkprocessService, ExplanationService, AssessmentCriteriaService, SemsoSnackbarService, GradeService],
  exports: [WorkprocessComponent]
})
export class WorkprocessModule { }



// WEBPACK FOOTER //
// ./src/app/examination/workprocess/workprocess.module.ts